import { useEffect, useState } from 'react';
import { getCreateAndEditValidation } from '../api/validationsAPI';
import { INVOICE_PAYMENT_VALIDATION_ERRORS, INVOICE_PROPERTY_VALIDATION_ERRORS } from 'invoices-ui-lib/constants/validations';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export const getInvoiceValidationErrorMessage = invoiceValidationMessage => {
  switch (invoiceValidationMessage.subCategory) {
    case INVOICE_PAYMENT_VALIDATION_ERRORS.UNSUPPORTED_CURRENCIES:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoicesHighlightCard.buttons.tooltips.cloneDisabled.reason.currency_jsx",
        elements: {
          UILink
        },
        options: {
          href: 'https://knowledge.hubspot.com/payments/use-multiple-currencies-with-stripe',
          external: true
        }
      }, invoiceValidationMessage.subCategory);
    case INVOICE_PAYMENT_VALIDATION_ERRORS.MULTIPLE_CURRENCIES_NOT_SUPPORTED:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoicesHighlightCard.buttons.tooltips.cloneDisabled.reason.multipleCurrencies"
      }, invoiceValidationMessage.subCategory);
    case INVOICE_PROPERTY_VALIDATION_ERRORS.INVALID_VALUE_FOR_PROPERTY_DEFINITION:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoicesHighlightCard.buttons.tooltips.cloneDisabled.reason.invalidProperty"
      }, invoiceValidationMessage.subCategory);
    default:
      return null;
  }
};

// Clone and edit are special validation cases and don't request checking all invoice properties.
// We can assume that the existing invoice is still valid.
const sanitizeInvoice = invoice => {
  return Object.assign({}, invoice, {
    properties: Object.keys(invoice.properties).filter(key => {
      var _invoice$properties$h;
      return key === 'hs_currency' || key === 'hs_custom_fields' || ((_invoice$properties$h = invoice.properties['hs_custom_fields']) === null || _invoice$properties$h === void 0 ? void 0 : _invoice$properties$h.value.split(';').includes(key));
    }).reduce((obj, key) => {
      obj[key] = invoice.properties[key] || {
        key,
        value: null
      };
      return obj;
    }, {})
  });
};
const useCanCreateInvoice = invoice => {
  const [loading, setLoading] = useState(true);
  const [disabledReasons, setDisabledReasons] = useState([]);
  const [unknownValidationError, setUnknownValidationError] = useState(false);
  useEffect(() => {
    getCreateAndEditValidation(sanitizeInvoice(invoice)).then(result => {
      const validationErrorMessages = result.map(validationMessage => getInvoiceValidationErrorMessage(validationMessage)).filter(Boolean);
      if (validationErrorMessages.length === result.length) {
        setDisabledReasons(validationErrorMessages);
      } else {
        Raven.captureMessage('[invoices-highlight-lib] Unexpected invoice validation error', {
          extra: {
            result,
            operation: 'clone'
          }
        });
        setUnknownValidationError(true);
      }
      setLoading(false);
    }).catch(() => {
      setLoading(false);
    });
  }, [invoice]);
  return {
    loading,
    disabledReasons,
    unknownValidationError
  };
};
export default useCanCreateInvoice;